import _definePage_default_0 from '/rails/app/frontend/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/rails/app/frontend/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/rails/app/frontend/pages/account/index.vue?definePage&vue'
import _definePage_default_4 from '/rails/app/frontend/pages/account/mollie.vue?definePage&vue'
import _definePage_default_5 from '/rails/app/frontend/pages/account-restricted.vue?definePage&vue'
import _definePage_default_6 from '/rails/app/frontend/pages/admin/index.vue?definePage&vue'
import _definePage_default_7 from '/rails/app/frontend/pages/admin/audit-logs.vue?definePage&vue'
import _definePage_default_8 from '/rails/app/frontend/pages/admin/billing-settings.vue?definePage&vue'
import _definePage_default_9 from '/rails/app/frontend/pages/admin/custom-exercise-submissions.vue?definePage&vue'
import _definePage_default_10 from '/rails/app/frontend/pages/admin/invoices/index.vue?definePage&vue'
import _definePage_default_11 from '/rails/app/frontend/pages/admin/invoices/[id].vue?definePage&vue'
import _definePage_default_12 from '/rails/app/frontend/pages/admin/login.vue?definePage&vue'
import _definePage_default_13 from '/rails/app/frontend/pages/admin/mollie-connection.vue?definePage&vue'
import _definePage_default_14 from '/rails/app/frontend/pages/admin/trainers/index.vue?definePage&vue'
import _definePage_default_15 from '/rails/app/frontend/pages/admin/trainers/[id].vue?definePage&vue'
import _definePage_default_16 from '/rails/app/frontend/pages/appointments/index.vue?definePage&vue'
import _definePage_default_17 from '/rails/app/frontend/pages/apps/chat.vue?definePage&vue'
import _definePage_default_18 from '/rails/app/frontend/pages/apps/email/index.vue?definePage&vue'
import _definePage_default_19 from '/rails/app/frontend/pages/apps/logistics/fleet.vue?definePage&vue'
import _definePage_default_20 from '/rails/app/frontend/pages/availability/index.vue?definePage&vue'
import _definePage_default_21 from '/rails/app/frontend/pages/cancellation-policy/index.vue?definePage&vue'
import _definePage_default_22 from '/rails/app/frontend/pages/client/accept-invite.vue?definePage&vue'
import _definePage_default_23 from '/rails/app/frontend/pages/client/billing.vue?definePage&vue'
import _definePage_default_24 from '/rails/app/frontend/pages/client/booking.vue?definePage&vue'
import _definePage_default_25 from '/rails/app/frontend/pages/client/forgot-password.vue?definePage&vue'
import _definePage_default_26 from '/rails/app/frontend/pages/client/login.vue?definePage&vue'
import _definePage_default_27 from '/rails/app/frontend/pages/client/profile.vue?definePage&vue'
import _definePage_default_28 from '/rails/app/frontend/pages/client/reset-password.vue?definePage&vue'
import _definePage_default_29 from '/rails/app/frontend/pages/client/today.vue?definePage&vue'
import _definePage_default_30 from '/rails/app/frontend/pages/clients/index.vue?definePage&vue'
import _definePage_default_31 from '/rails/app/frontend/pages/clients/[id].vue?definePage&vue'
import _definePage_default_32 from '/rails/app/frontend/pages/confirm-email.vue?definePage&vue'
import _definePage_default_33 from '/rails/app/frontend/pages/dashboard/index.vue?definePage&vue'
import _definePage_default_34 from '/rails/app/frontend/pages/forgot-password.vue?definePage&vue'
import _definePage_default_35 from '/rails/app/frontend/pages/front-pages/checkout.vue?definePage&vue'
import _definePage_default_36 from '/rails/app/frontend/pages/front-pages/help-center/index.vue?definePage&vue'
import _definePage_default_37 from '/rails/app/frontend/pages/front-pages/help-center/article/[title].vue?definePage&vue'
import _definePage_default_38 from '/rails/app/frontend/pages/front-pages/landing-page/index.vue?definePage&vue'
import _definePage_default_39 from '/rails/app/frontend/pages/front-pages/payment.vue?definePage&vue'
import _definePage_default_40 from '/rails/app/frontend/pages/front-pages/pricing.vue?definePage&vue'
import _definePage_default_41 from '/rails/app/frontend/pages/insights/index.vue?definePage&vue'
import _definePage_default_42 from '/rails/app/frontend/pages/landing.vue?definePage&vue'
import _definePage_default_43 from '/rails/app/frontend/pages/login.vue?definePage&vue'
import _definePage_default_44 from '/rails/app/frontend/pages/not-authorized.vue?definePage&vue'
import _definePage_default_45 from '/rails/app/frontend/pages/notification-templates/index.vue?definePage&vue'
import _definePage_default_46 from '/rails/app/frontend/pages/notification-templates/[id].vue?definePage&vue'
import _definePage_default_47 from '/rails/app/frontend/pages/notifications/index.vue?definePage&vue'
import _definePage_default_48 from '/rails/app/frontend/pages/onboarding.vue?definePage&vue'
import _definePage_default_49 from '/rails/app/frontend/pages/pages/account-settings/[tab].vue?definePage&vue'
import _definePage_default_50 from '/rails/app/frontend/pages/pages/authentication/forgot-password-v1.vue?definePage&vue'
import _definePage_default_51 from '/rails/app/frontend/pages/pages/authentication/forgot-password-v2.vue?definePage&vue'
import _definePage_default_52 from '/rails/app/frontend/pages/pages/authentication/login-v1.vue?definePage&vue'
import _definePage_default_53 from '/rails/app/frontend/pages/pages/authentication/login-v2.vue?definePage&vue'
import _definePage_default_54 from '/rails/app/frontend/pages/pages/authentication/register-multi-steps.vue?definePage&vue'
import _definePage_default_55 from '/rails/app/frontend/pages/pages/authentication/register-v1.vue?definePage&vue'
import _definePage_default_56 from '/rails/app/frontend/pages/pages/authentication/register-v2.vue?definePage&vue'
import _definePage_default_57 from '/rails/app/frontend/pages/pages/authentication/reset-password-v1.vue?definePage&vue'
import _definePage_default_58 from '/rails/app/frontend/pages/pages/authentication/reset-password-v2.vue?definePage&vue'
import _definePage_default_59 from '/rails/app/frontend/pages/pages/authentication/two-steps-v1.vue?definePage&vue'
import _definePage_default_60 from '/rails/app/frontend/pages/pages/authentication/two-steps-v2.vue?definePage&vue'
import _definePage_default_61 from '/rails/app/frontend/pages/pages/authentication/verify-email-v1.vue?definePage&vue'
import _definePage_default_62 from '/rails/app/frontend/pages/pages/authentication/verify-email-v2.vue?definePage&vue'
import _definePage_default_63 from '/rails/app/frontend/pages/pages/misc/coming-soon.vue?definePage&vue'
import _definePage_default_64 from '/rails/app/frontend/pages/pages/misc/under-maintenance.vue?definePage&vue'
import _definePage_default_65 from '/rails/app/frontend/pages/pages/user-profile/[tab].vue?definePage&vue'
import _definePage_default_66 from '/rails/app/frontend/pages/pricing-plans/index.vue?definePage&vue'
import _definePage_default_67 from '/rails/app/frontend/pages/pricing-plans/[id].vue?definePage&vue'
import _definePage_default_68 from '/rails/app/frontend/pages/register.vue?definePage&vue'
import _definePage_default_69 from '/rails/app/frontend/pages/reset-password.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/rails/app/frontend/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/rails/app/frontend/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/account',
    /* internal name: 'account' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'account',
        component: () => import('/rails/app/frontend/pages/account/index.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'mollie',
        name: 'account-mollie',
        component: () => import('/rails/app/frontend/pages/account/mollie.vue'),
        /* no children */
      },
  _definePage_default_4
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/account-restricted',
    name: 'account-restricted',
    component: () => import('/rails/app/frontend/pages/account-restricted.vue'),
    /* no children */
  },
  _definePage_default_5
  ),
  {
    path: '/admin',
    /* internal name: 'admin' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'admin',
        component: () => import('/rails/app/frontend/pages/admin/index.vue'),
        /* no children */
      },
  _definePage_default_6
  ),
  _mergeRouteRecord(
      {
        path: 'audit-logs',
        name: 'admin-audit-logs',
        component: () => import('/rails/app/frontend/pages/admin/audit-logs.vue'),
        /* no children */
      },
  _definePage_default_7
  ),
  _mergeRouteRecord(
      {
        path: 'billing-settings',
        name: 'admin-billing-settings',
        component: () => import('/rails/app/frontend/pages/admin/billing-settings.vue'),
        /* no children */
      },
  _definePage_default_8
  ),
  _mergeRouteRecord(
      {
        path: 'custom-exercise-submissions',
        name: 'admin-custom-exercise-submissions',
        component: () => import('/rails/app/frontend/pages/admin/custom-exercise-submissions.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
      {
        path: 'invoices',
        /* internal name: 'admin-invoices' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-invoices',
            component: () => import('/rails/app/frontend/pages/admin/invoices/index.vue'),
            /* no children */
          },
  _definePage_default_10
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'admin-invoices-id',
            component: () => import('/rails/app/frontend/pages/admin/invoices/[id].vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'admin-login',
        component: () => import('/rails/app/frontend/pages/admin/login.vue'),
        /* no children */
      },
  _definePage_default_12
  ),
  _mergeRouteRecord(
      {
        path: 'mollie-connection',
        name: 'admin-mollie-connection',
        component: () => import('/rails/app/frontend/pages/admin/mollie-connection.vue'),
        /* no children */
      },
  _definePage_default_13
  ),
      {
        path: 'trainers',
        /* internal name: 'admin-trainers' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'admin-trainers',
            component: () => import('/rails/app/frontend/pages/admin/trainers/index.vue'),
            /* no children */
          },
  _definePage_default_14
  ),
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'admin-trainers-id',
            component: () => import('/rails/app/frontend/pages/admin/trainers/[id].vue'),
            /* no children */
          },
  _definePage_default_15
  )
        ],
      }
    ],
  },
  {
    path: '/appointments',
    /* internal name: 'appointments' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'appointments',
        component: () => import('/rails/app/frontend/pages/appointments/index.vue'),
        /* no children */
      },
  _definePage_default_16
  )
    ],
  },
  {
    path: '/apps',
    /* internal name: 'apps' */
    /* no component */
    children: [
      {
        path: 'academy',
        /* internal name: 'apps-academy' */
        /* no component */
        children: [
          {
            path: 'course-details',
            name: 'apps-academy-course-details',
            component: () => import('/rails/app/frontend/pages/apps/academy/course-details.vue'),
            /* no children */
          },
          {
            path: 'dashboard',
            name: 'apps-academy-dashboard',
            component: () => import('/rails/app/frontend/pages/apps/academy/dashboard.vue'),
            /* no children */
          },
          {
            path: 'my-course',
            name: 'apps-academy-my-course',
            component: () => import('/rails/app/frontend/pages/apps/academy/my-course.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'calendar',
        name: 'apps-calendar',
        component: () => import('/rails/app/frontend/pages/apps/calendar.vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'chat',
        name: 'apps-chat',
        component: () => import('/rails/app/frontend/pages/apps/chat.vue'),
        /* no children */
      },
  _definePage_default_17
  ),
      {
        path: 'ecommerce',
        /* internal name: 'apps-ecommerce' */
        /* no component */
        children: [
          {
            path: 'customer',
            /* internal name: 'apps-ecommerce-customer' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-customer-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-customer-details-id',
                    component: () => import('/rails/app/frontend/pages/apps/ecommerce/customer/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-customer-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-customer-list',
                    component: () => import('/rails/app/frontend/pages/apps/ecommerce/customer/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'manage-review',
            name: 'apps-ecommerce-manage-review',
            component: () => import('/rails/app/frontend/pages/apps/ecommerce/manage-review.vue'),
            /* no children */
          },
          {
            path: 'order',
            /* internal name: 'apps-ecommerce-order' */
            /* no component */
            children: [
              {
                path: 'details',
                /* internal name: 'apps-ecommerce-order-details' */
                /* no component */
                children: [
                  {
                    path: ':id',
                    name: 'apps-ecommerce-order-details-id',
                    component: () => import('/rails/app/frontend/pages/apps/ecommerce/order/details/[id].vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-order-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-order-list',
                    component: () => import('/rails/app/frontend/pages/apps/ecommerce/order/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'product',
            /* internal name: 'apps-ecommerce-product' */
            /* no component */
            children: [
              {
                path: 'add',
                /* internal name: 'apps-ecommerce-product-add' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-add',
                    component: () => import('/rails/app/frontend/pages/apps/ecommerce/product/add/index.vue'),
                    /* no children */
                  }
                ],
              },
              {
                path: 'category-list',
                name: 'apps-ecommerce-product-category-list',
                component: () => import('/rails/app/frontend/pages/apps/ecommerce/product/category-list.vue'),
                /* no children */
              },
              {
                path: 'list',
                /* internal name: 'apps-ecommerce-product-list' */
                /* no component */
                children: [
                  {
                    path: '',
                    name: 'apps-ecommerce-product-list',
                    component: () => import('/rails/app/frontend/pages/apps/ecommerce/product/list/index.vue'),
                    /* no children */
                  }
                ],
              }
            ],
          },
          {
            path: 'referrals',
            name: 'apps-ecommerce-referrals',
            component: () => import('/rails/app/frontend/pages/apps/ecommerce/referrals.vue'),
            /* no children */
          },
          {
            path: 'settings',
            name: 'apps-ecommerce-settings',
            component: () => import('/rails/app/frontend/pages/apps/ecommerce/settings.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'email',
        /* internal name: 'apps-email' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'apps-email',
            component: () => import('/rails/app/frontend/pages/apps/email/index.vue'),
            /* no children */
          },
  _definePage_default_18
  )
        ],
      },
      {
        path: 'invoice',
        /* internal name: 'apps-invoice' */
        /* no component */
        children: [
          {
            path: 'add',
            /* internal name: 'apps-invoice-add' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-add',
                component: () => import('/rails/app/frontend/pages/apps/invoice/add/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'edit',
            /* internal name: 'apps-invoice-edit' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-edit-id',
                component: () => import('/rails/app/frontend/pages/apps/invoice/edit/[id].vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'list',
            /* internal name: 'apps-invoice-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-invoice-list',
                component: () => import('/rails/app/frontend/pages/apps/invoice/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'preview',
            /* internal name: 'apps-invoice-preview' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-invoice-preview-id',
                component: () => import('/rails/app/frontend/pages/apps/invoice/preview/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      },
      {
        path: 'kanban',
        /* internal name: 'apps-kanban' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-kanban',
            component: () => import('/rails/app/frontend/pages/apps/kanban/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'logistics',
        /* internal name: 'apps-logistics' */
        /* no component */
        children: [
          {
            path: 'dashboard',
            name: 'apps-logistics-dashboard',
            component: () => import('/rails/app/frontend/pages/apps/logistics/dashboard.vue'),
            /* no children */
          },
  _mergeRouteRecord(
          {
            path: 'fleet',
            name: 'apps-logistics-fleet',
            component: () => import('/rails/app/frontend/pages/apps/logistics/fleet.vue'),
            /* no children */
          },
  _definePage_default_19
  )
        ],
      },
      {
        path: 'permissions',
        /* internal name: 'apps-permissions' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-permissions',
            component: () => import('/rails/app/frontend/pages/apps/permissions/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'roles',
        /* internal name: 'apps-roles' */
        /* no component */
        children: [
          {
            path: '',
            name: 'apps-roles',
            component: () => import('/rails/app/frontend/pages/apps/roles/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'user',
        /* internal name: 'apps-user' */
        /* no component */
        children: [
          {
            path: 'list',
            /* internal name: 'apps-user-list' */
            /* no component */
            children: [
              {
                path: '',
                name: 'apps-user-list',
                component: () => import('/rails/app/frontend/pages/apps/user/list/index.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'view',
            /* internal name: 'apps-user-view' */
            /* no component */
            children: [
              {
                path: ':id',
                name: 'apps-user-view-id',
                component: () => import('/rails/app/frontend/pages/apps/user/view/[id].vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/apps/email/:filter',
    name: 'apps-email-filter',
    component: () => import('/rails/app/frontend/pages/apps/email/index.vue'),
    /* no children */
  },
  {
    path: '/apps/email/:label',
    name: 'apps-email-label',
    component: () => import('/rails/app/frontend/pages/apps/email/index.vue'),
    /* no children */
  },
  {
    path: '/availability',
    /* internal name: 'availability' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'availability',
        component: () => import('/rails/app/frontend/pages/availability/index.vue'),
        /* no children */
      },
  _definePage_default_20
  )
    ],
  },
  {
    path: '/cancellation-policy',
    /* internal name: 'cancellation-policy' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'cancellation-policy',
        component: () => import('/rails/app/frontend/pages/cancellation-policy/index.vue'),
        /* no children */
      },
  _definePage_default_21
  )
    ],
  },
  {
    path: '/charts',
    /* internal name: 'charts' */
    /* no component */
    children: [
      {
        path: 'apex-chart',
        name: 'charts-apex-chart',
        component: () => import('/rails/app/frontend/pages/charts/apex-chart.vue'),
        /* no children */
      },
      {
        path: 'chartjs',
        name: 'charts-chartjs',
        component: () => import('/rails/app/frontend/pages/charts/chartjs.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/client',
    /* internal name: 'client' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'accept-invite',
        name: 'client-accept-invite',
        component: () => import('/rails/app/frontend/pages/client/accept-invite.vue'),
        /* no children */
      },
  _definePage_default_22
  ),
  _mergeRouteRecord(
      {
        path: 'billing',
        name: 'client-billing',
        component: () => import('/rails/app/frontend/pages/client/billing.vue'),
        /* no children */
      },
  _definePage_default_23
  ),
  _mergeRouteRecord(
      {
        path: 'booking',
        name: 'client-booking',
        component: () => import('/rails/app/frontend/pages/client/booking.vue'),
        /* no children */
      },
  _definePage_default_24
  ),
  _mergeRouteRecord(
      {
        path: 'forgot-password',
        name: 'client-forgot-password',
        component: () => import('/rails/app/frontend/pages/client/forgot-password.vue'),
        /* no children */
      },
  _definePage_default_25
  ),
  _mergeRouteRecord(
      {
        path: 'login',
        name: 'client-login',
        component: () => import('/rails/app/frontend/pages/client/login.vue'),
        /* no children */
      },
  _definePage_default_26
  ),
  _mergeRouteRecord(
      {
        path: 'profile',
        name: 'client-profile',
        component: () => import('/rails/app/frontend/pages/client/profile.vue'),
        /* no children */
      },
  _definePage_default_27
  ),
  _mergeRouteRecord(
      {
        path: 'reset-password',
        name: 'client-reset-password',
        component: () => import('/rails/app/frontend/pages/client/reset-password.vue'),
        /* no children */
      },
  _definePage_default_28
  ),
  _mergeRouteRecord(
      {
        path: 'today',
        name: 'client-today',
        component: () => import('/rails/app/frontend/pages/client/today.vue'),
        /* no children */
      },
  _definePage_default_29
  )
    ],
  },
  {
    path: '/clients',
    /* internal name: 'clients' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'clients',
        component: () => import('/rails/app/frontend/pages/clients/index.vue'),
        /* no children */
      },
  _definePage_default_30
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'clients-id',
        component: () => import('/rails/app/frontend/pages/clients/[id].vue'),
        /* no children */
      },
  _definePage_default_31
  )
    ],
  },
  {
    path: '/components',
    /* internal name: 'components' */
    /* no component */
    children: [
      {
        path: 'alert',
        name: 'components-alert',
        component: () => import('/rails/app/frontend/pages/components/alert.vue'),
        /* no children */
      },
      {
        path: 'avatar',
        name: 'components-avatar',
        component: () => import('/rails/app/frontend/pages/components/avatar.vue'),
        /* no children */
      },
      {
        path: 'badge',
        name: 'components-badge',
        component: () => import('/rails/app/frontend/pages/components/badge.vue'),
        /* no children */
      },
      {
        path: 'button',
        name: 'components-button',
        component: () => import('/rails/app/frontend/pages/components/button.vue'),
        /* no children */
      },
      {
        path: 'chip',
        name: 'components-chip',
        component: () => import('/rails/app/frontend/pages/components/chip.vue'),
        /* no children */
      },
      {
        path: 'dialog',
        name: 'components-dialog',
        component: () => import('/rails/app/frontend/pages/components/dialog.vue'),
        /* no children */
      },
      {
        path: 'expansion-panel',
        name: 'components-expansion-panel',
        component: () => import('/rails/app/frontend/pages/components/expansion-panel.vue'),
        /* no children */
      },
      {
        path: 'list',
        name: 'components-list',
        component: () => import('/rails/app/frontend/pages/components/list.vue'),
        /* no children */
      },
      {
        path: 'menu',
        name: 'components-menu',
        component: () => import('/rails/app/frontend/pages/components/menu.vue'),
        /* no children */
      },
      {
        path: 'pagination',
        name: 'components-pagination',
        component: () => import('/rails/app/frontend/pages/components/pagination.vue'),
        /* no children */
      },
      {
        path: 'progress-circular',
        name: 'components-progress-circular',
        component: () => import('/rails/app/frontend/pages/components/progress-circular.vue'),
        /* no children */
      },
      {
        path: 'progress-linear',
        name: 'components-progress-linear',
        component: () => import('/rails/app/frontend/pages/components/progress-linear.vue'),
        /* no children */
      },
      {
        path: 'snackbar',
        name: 'components-snackbar',
        component: () => import('/rails/app/frontend/pages/components/snackbar.vue'),
        /* no children */
      },
      {
        path: 'tabs',
        name: 'components-tabs',
        component: () => import('/rails/app/frontend/pages/components/tabs.vue'),
        /* no children */
      },
      {
        path: 'timeline',
        name: 'components-timeline',
        component: () => import('/rails/app/frontend/pages/components/timeline.vue'),
        /* no children */
      },
      {
        path: 'tooltip',
        name: 'components-tooltip',
        component: () => import('/rails/app/frontend/pages/components/tooltip.vue'),
        /* no children */
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/confirm-email',
    name: 'confirm-email',
    component: () => import('/rails/app/frontend/pages/confirm-email.vue'),
    /* no children */
  },
  _definePage_default_32
  ),
  {
    path: '/dashboard',
    /* internal name: 'dashboard' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'dashboard',
        component: () => import('/rails/app/frontend/pages/dashboard/index.vue'),
        /* no children */
      },
  _definePage_default_33
  )
    ],
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: 'analytics',
        name: 'dashboards-analytics',
        component: () => import('/rails/app/frontend/pages/dashboards/analytics.vue'),
        /* no children */
      },
      {
        path: 'crm',
        name: 'dashboards-crm',
        component: () => import('/rails/app/frontend/pages/dashboards/crm.vue'),
        /* no children */
      },
      {
        path: 'ecommerce',
        name: 'dashboards-ecommerce',
        component: () => import('/rails/app/frontend/pages/dashboards/ecommerce.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/extensions',
    /* internal name: 'extensions' */
    /* no component */
    children: [
      {
        path: 'swiper',
        name: 'extensions-swiper',
        component: () => import('/rails/app/frontend/pages/extensions/swiper.vue'),
        /* no children */
      },
      {
        path: 'tour',
        name: 'extensions-tour',
        component: () => import('/rails/app/frontend/pages/extensions/tour.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/figma',
    name: 'figma',
    component: () => import('/rails/app/frontend/pages/figma.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/rails/app/frontend/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_34
  ),
  {
    path: '/forms',
    /* internal name: 'forms' */
    /* no component */
    children: [
      {
        path: 'autocomplete',
        name: 'forms-autocomplete',
        component: () => import('/rails/app/frontend/pages/forms/autocomplete.vue'),
        /* no children */
      },
      {
        path: 'checkbox',
        name: 'forms-checkbox',
        component: () => import('/rails/app/frontend/pages/forms/checkbox.vue'),
        /* no children */
      },
      {
        path: 'combobox',
        name: 'forms-combobox',
        component: () => import('/rails/app/frontend/pages/forms/combobox.vue'),
        /* no children */
      },
      {
        path: 'custom-input',
        name: 'forms-custom-input',
        component: () => import('/rails/app/frontend/pages/forms/custom-input.vue'),
        /* no children */
      },
      {
        path: 'date-time-picker',
        name: 'forms-date-time-picker',
        component: () => import('/rails/app/frontend/pages/forms/date-time-picker.vue'),
        /* no children */
      },
      {
        path: 'editors',
        name: 'forms-editors',
        component: () => import('/rails/app/frontend/pages/forms/editors.vue'),
        /* no children */
      },
      {
        path: 'file-input',
        name: 'forms-file-input',
        component: () => import('/rails/app/frontend/pages/forms/file-input.vue'),
        /* no children */
      },
      {
        path: 'form-layouts',
        name: 'forms-form-layouts',
        component: () => import('/rails/app/frontend/pages/forms/form-layouts.vue'),
        /* no children */
      },
      {
        path: 'form-validation',
        name: 'forms-form-validation',
        component: () => import('/rails/app/frontend/pages/forms/form-validation.vue'),
        /* no children */
      },
      {
        path: 'form-wizard-icons',
        name: 'forms-form-wizard-icons',
        component: () => import('/rails/app/frontend/pages/forms/form-wizard-icons.vue'),
        /* no children */
      },
      {
        path: 'form-wizard-numbered',
        name: 'forms-form-wizard-numbered',
        component: () => import('/rails/app/frontend/pages/forms/form-wizard-numbered.vue'),
        /* no children */
      },
      {
        path: 'radio',
        name: 'forms-radio',
        component: () => import('/rails/app/frontend/pages/forms/radio.vue'),
        /* no children */
      },
      {
        path: 'range-slider',
        name: 'forms-range-slider',
        component: () => import('/rails/app/frontend/pages/forms/range-slider.vue'),
        /* no children */
      },
      {
        path: 'rating',
        name: 'forms-rating',
        component: () => import('/rails/app/frontend/pages/forms/rating.vue'),
        /* no children */
      },
      {
        path: 'select',
        name: 'forms-select',
        component: () => import('/rails/app/frontend/pages/forms/select.vue'),
        /* no children */
      },
      {
        path: 'slider',
        name: 'forms-slider',
        component: () => import('/rails/app/frontend/pages/forms/slider.vue'),
        /* no children */
      },
      {
        path: 'switch',
        name: 'forms-switch',
        component: () => import('/rails/app/frontend/pages/forms/switch.vue'),
        /* no children */
      },
      {
        path: 'textarea',
        name: 'forms-textarea',
        component: () => import('/rails/app/frontend/pages/forms/textarea.vue'),
        /* no children */
      },
      {
        path: 'textfield',
        name: 'forms-textfield',
        component: () => import('/rails/app/frontend/pages/forms/textfield.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/front-pages',
    /* internal name: 'front-pages' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'checkout',
        name: 'front-pages-checkout',
        component: () => import('/rails/app/frontend/pages/front-pages/checkout.vue'),
        /* no children */
      },
  _definePage_default_35
  ),
      {
        path: 'help-center',
        /* internal name: 'front-pages-help-center' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'front-pages-help-center',
            component: () => import('/rails/app/frontend/pages/front-pages/help-center/index.vue'),
            /* no children */
          },
  _definePage_default_36
  ),
          {
            path: 'article',
            /* internal name: 'front-pages-help-center-article' */
            /* no component */
            children: [
  _mergeRouteRecord(
              {
                path: ':title',
                name: 'front-pages-help-center-article-title',
                component: () => import('/rails/app/frontend/pages/front-pages/help-center/article/[title].vue'),
                /* no children */
              },
  _definePage_default_37
  )
            ],
          }
        ],
      },
      {
        path: 'landing-page',
        /* internal name: 'front-pages-landing-page' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: 'front-pages-landing-page',
            component: () => import('/rails/app/frontend/pages/front-pages/landing-page/index.vue'),
            /* no children */
          },
  _definePage_default_38
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'payment',
        name: 'front-pages-payment',
        component: () => import('/rails/app/frontend/pages/front-pages/payment.vue'),
        /* no children */
      },
  _definePage_default_39
  ),
  _mergeRouteRecord(
      {
        path: 'pricing',
        name: 'front-pages-pricing',
        component: () => import('/rails/app/frontend/pages/front-pages/pricing.vue'),
        /* no children */
      },
  _definePage_default_40
  )
    ],
  },
  {
    path: '/insights',
    /* internal name: 'insights' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'insights',
        component: () => import('/rails/app/frontend/pages/insights/index.vue'),
        /* no children */
      },
  _definePage_default_41
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/landing',
    name: 'landing',
    component: () => import('/rails/app/frontend/pages/landing.vue'),
    /* no children */
  },
  _definePage_default_42
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/rails/app/frontend/pages/login.vue'),
    /* no children */
  },
  _definePage_default_43
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/rails/app/frontend/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_44
  ),
  {
    path: '/notification-templates',
    /* internal name: 'notification-templates' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'notification-templates',
        component: () => import('/rails/app/frontend/pages/notification-templates/index.vue'),
        /* no children */
      },
  _definePage_default_45
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'notification-templates-id',
        component: () => import('/rails/app/frontend/pages/notification-templates/[id].vue'),
        /* no children */
      },
  _definePage_default_46
  )
    ],
  },
  {
    path: '/notifications',
    /* internal name: 'notifications' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'notifications',
        component: () => import('/rails/app/frontend/pages/notifications/index.vue'),
        /* no children */
      },
  _definePage_default_47
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/onboarding',
    name: 'onboarding',
    component: () => import('/rails/app/frontend/pages/onboarding.vue'),
    /* no children */
  },
  _definePage_default_48
  ),
  {
    path: '/pages',
    /* internal name: 'pages' */
    /* no component */
    children: [
      {
        path: 'account-settings',
        /* internal name: 'pages-account-settings' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-account-settings-tab',
            component: () => import('/rails/app/frontend/pages/pages/account-settings/[tab].vue'),
            /* no children */
          },
  _definePage_default_49
  )
        ],
      },
      {
        path: 'authentication',
        /* internal name: 'pages-authentication' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'forgot-password-v1',
            name: 'pages-authentication-forgot-password-v1',
            component: () => import('/rails/app/frontend/pages/pages/authentication/forgot-password-v1.vue'),
            /* no children */
          },
  _definePage_default_50
  ),
  _mergeRouteRecord(
          {
            path: 'forgot-password-v2',
            name: 'pages-authentication-forgot-password-v2',
            component: () => import('/rails/app/frontend/pages/pages/authentication/forgot-password-v2.vue'),
            /* no children */
          },
  _definePage_default_51
  ),
  _mergeRouteRecord(
          {
            path: 'login-v1',
            name: 'pages-authentication-login-v1',
            component: () => import('/rails/app/frontend/pages/pages/authentication/login-v1.vue'),
            /* no children */
          },
  _definePage_default_52
  ),
  _mergeRouteRecord(
          {
            path: 'login-v2',
            name: 'pages-authentication-login-v2',
            component: () => import('/rails/app/frontend/pages/pages/authentication/login-v2.vue'),
            /* no children */
          },
  _definePage_default_53
  ),
  _mergeRouteRecord(
          {
            path: 'register-multi-steps',
            name: 'pages-authentication-register-multi-steps',
            component: () => import('/rails/app/frontend/pages/pages/authentication/register-multi-steps.vue'),
            /* no children */
          },
  _definePage_default_54
  ),
  _mergeRouteRecord(
          {
            path: 'register-v1',
            name: 'pages-authentication-register-v1',
            component: () => import('/rails/app/frontend/pages/pages/authentication/register-v1.vue'),
            /* no children */
          },
  _definePage_default_55
  ),
  _mergeRouteRecord(
          {
            path: 'register-v2',
            name: 'pages-authentication-register-v2',
            component: () => import('/rails/app/frontend/pages/pages/authentication/register-v2.vue'),
            /* no children */
          },
  _definePage_default_56
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password-v1',
            name: 'pages-authentication-reset-password-v1',
            component: () => import('/rails/app/frontend/pages/pages/authentication/reset-password-v1.vue'),
            /* no children */
          },
  _definePage_default_57
  ),
  _mergeRouteRecord(
          {
            path: 'reset-password-v2',
            name: 'pages-authentication-reset-password-v2',
            component: () => import('/rails/app/frontend/pages/pages/authentication/reset-password-v2.vue'),
            /* no children */
          },
  _definePage_default_58
  ),
  _mergeRouteRecord(
          {
            path: 'two-steps-v1',
            name: 'pages-authentication-two-steps-v1',
            component: () => import('/rails/app/frontend/pages/pages/authentication/two-steps-v1.vue'),
            /* no children */
          },
  _definePage_default_59
  ),
  _mergeRouteRecord(
          {
            path: 'two-steps-v2',
            name: 'pages-authentication-two-steps-v2',
            component: () => import('/rails/app/frontend/pages/pages/authentication/two-steps-v2.vue'),
            /* no children */
          },
  _definePage_default_60
  ),
  _mergeRouteRecord(
          {
            path: 'verify-email-v1',
            name: 'pages-authentication-verify-email-v1',
            component: () => import('/rails/app/frontend/pages/pages/authentication/verify-email-v1.vue'),
            /* no children */
          },
  _definePage_default_61
  ),
  _mergeRouteRecord(
          {
            path: 'verify-email-v2',
            name: 'pages-authentication-verify-email-v2',
            component: () => import('/rails/app/frontend/pages/pages/authentication/verify-email-v2.vue'),
            /* no children */
          },
  _definePage_default_62
  )
        ],
      },
      {
        path: 'cards',
        /* internal name: 'pages-cards' */
        /* no component */
        children: [
          {
            path: 'card-actions',
            name: 'pages-cards-card-actions',
            component: () => import('/rails/app/frontend/pages/pages/cards/card-actions.vue'),
            /* no children */
          },
          {
            path: 'card-advance',
            name: 'pages-cards-card-advance',
            component: () => import('/rails/app/frontend/pages/pages/cards/card-advance.vue'),
            /* no children */
          },
          {
            path: 'card-basic',
            name: 'pages-cards-card-basic',
            component: () => import('/rails/app/frontend/pages/pages/cards/card-basic.vue'),
            /* no children */
          },
          {
            path: 'card-gamification',
            name: 'pages-cards-card-gamification',
            component: () => import('/rails/app/frontend/pages/pages/cards/card-gamification.vue'),
            /* no children */
          },
          {
            path: 'card-statistics',
            name: 'pages-cards-card-statistics',
            component: () => import('/rails/app/frontend/pages/pages/cards/card-statistics.vue'),
            /* no children */
          },
          {
            path: 'card-widgets',
            name: 'pages-cards-card-widgets',
            component: () => import('/rails/app/frontend/pages/pages/cards/card-widgets.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'dialog-examples',
        /* internal name: 'pages-dialog-examples' */
        /* no component */
        children: [
          {
            path: '',
            name: 'pages-dialog-examples',
            component: () => import('/rails/app/frontend/pages/pages/dialog-examples/index.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'faq',
        name: 'pages-faq',
        component: () => import('/rails/app/frontend/pages/pages/faq.vue'),
        /* no children */
      },
      {
        path: 'icons',
        name: 'pages-icons',
        component: () => import('/rails/app/frontend/pages/pages/icons.vue'),
        /* no children */
      },
      {
        path: 'misc',
        /* internal name: 'pages-misc' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'coming-soon',
            name: 'pages-misc-coming-soon',
            component: () => import('/rails/app/frontend/pages/pages/misc/coming-soon.vue'),
            /* no children */
          },
  _definePage_default_63
  ),
  _mergeRouteRecord(
          {
            path: 'under-maintenance',
            name: 'pages-misc-under-maintenance',
            component: () => import('/rails/app/frontend/pages/pages/misc/under-maintenance.vue'),
            /* no children */
          },
  _definePage_default_64
  )
        ],
      },
      {
        path: 'pricing',
        name: 'pages-pricing',
        component: () => import('/rails/app/frontend/pages/pages/pricing.vue'),
        /* no children */
      },
      {
        path: 'typography',
        name: 'pages-typography',
        component: () => import('/rails/app/frontend/pages/pages/typography.vue'),
        /* no children */
      },
      {
        path: 'user-profile',
        /* internal name: 'pages-user-profile' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':tab',
            name: 'pages-user-profile-tab',
            component: () => import('/rails/app/frontend/pages/pages/user-profile/[tab].vue'),
            /* no children */
          },
  _definePage_default_65
  )
        ],
      }
    ],
  },
  {
    path: '/pricing-plans',
    /* internal name: 'pricing-plans' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: 'pricing-plans',
        component: () => import('/rails/app/frontend/pages/pricing-plans/index.vue'),
        /* no children */
      },
  _definePage_default_66
  ),
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'pricing-plans-id',
        component: () => import('/rails/app/frontend/pages/pricing-plans/[id].vue'),
        /* no children */
      },
  _definePage_default_67
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/rails/app/frontend/pages/register.vue'),
    /* no children */
  },
  _definePage_default_68
  ),
  _mergeRouteRecord(
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('/rails/app/frontend/pages/reset-password.vue'),
    /* no children */
  },
  _definePage_default_69
  ),
  {
    path: '/tables',
    /* internal name: 'tables' */
    /* no component */
    children: [
      {
        path: 'data-table',
        name: 'tables-data-table',
        component: () => import('/rails/app/frontend/pages/tables/data-table.vue'),
        /* no children */
      },
      {
        path: 'simple-table',
        name: 'tables-simple-table',
        component: () => import('/rails/app/frontend/pages/tables/simple-table.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/wizard-examples',
    /* internal name: 'wizard-examples' */
    /* no component */
    children: [
      {
        path: 'checkout',
        name: 'wizard-examples-checkout',
        component: () => import('/rails/app/frontend/pages/wizard-examples/checkout.vue'),
        /* no children */
      },
      {
        path: 'create-deal',
        name: 'wizard-examples-create-deal',
        component: () => import('/rails/app/frontend/pages/wizard-examples/create-deal.vue'),
        /* no children */
      },
      {
        path: 'property-listing',
        name: 'wizard-examples-property-listing',
        component: () => import('/rails/app/frontend/pages/wizard-examples/property-listing.vue'),
        /* no children */
      }
    ],
  }
]
